import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BannerCommon } from 'src/app/shared/types/banner-common.types';
import { environment } from 'src/environments/environment';
import { ICampaign } from '../advertiser/campaigns/model/campaign';
import { HttpUtilsService } from '../shared/http-utils/http-utils.service';
import { ListResponseWrapper } from '../shared/http.types';
import { Banner } from '../shared/types/banner.types';

export enum HintsSearchType {
  CATEGORY_PATHS = 'CATEGORY_PATHS',
  PHRASES = 'PHRASES',
  PROFILES = 'PROFILES',
}

export interface ChangeStatusPayload {
  bannerId: number;
  bannerModerateStatus: BannerCommon.ModerateStatus,
  msg?: string;
}

@Injectable({ providedIn: 'root' })
export class AdvertiserBannerHttpService {
  constructor(
    private httpClient: HttpClient,
    private httpUtils: HttpUtilsService,
  ) {}

  public getBanners(campaignId: ICampaign['id']): Observable<Banner[]> {
    const page = 1;
    const pageSize = 10000;
    return this.httpClient.get<ListResponseWrapper<Banner>>(
      `${environment.backendBaseUrlV2}/banners/campaign/${campaignId}`,
      {
        params: { page, pageSize }
      }
    )
      .pipe(map(this.httpUtils.listWrapperResponseMapper));
  }

  public changeStatus({ bannerId, ...payload }: ChangeStatusPayload): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendBaseUrlV2}/banners/${bannerId}/moderation-status`, payload);
  }

}
